import actions from './actions';

const initState = {
  loading: false,
  error: null,
  activeAgentResponseData: [],
  agentTransactionsResponseData: [],
  totalData: null,
  totalDataTransactions: null,
  agentTransactionsDetailsResponseData: [],
};

export default function AgentDetailsReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ACTIVE_AGENT:
    case actions.GET_AGENT_TRANSACTIONS:
    case actions.GET_AGENT_TRANSACTIONS_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_ACTIVE_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        activeAgentResponseData: action.payload.data || [],
        totalData: action.payload.totalData,
      };
    case actions.GET_AGENT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        agentTransactionsResponseData: action.payload.data || [],
        totalDataTransactions: action.payload.totalData,
      };
    case actions.GET_AGENT_TRANSACTIONS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        agentTransactionsDetailsResponseData: action.payload.data || [],
      };
    case actions.GET_ACTIVE_AGENT_FAILED:
    case actions.GET_AGENT_TRANSACTIONS_FAILED:
    case actions.GET_AGENT_TRANSACTIONS_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
